import { ILegalEntity } from './legal-entity';

export interface LegalEntityResponse {
  links: { string: string };
  count: number;
  totalCount: number;
  legalEntities: ILegalEntity[];
}
